type PreviewIconProps = {
    className?: string;
    width?: number;
    height?: number;
};

export const PreviewIcon = ({ className, width = 16, height = 18 }: PreviewIconProps) => {
    return (
        <svg width={width} height={height} className={className} viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M14.7441 7.18808L2.60126 0.277137C1.3132 -0.45821 0 0.346 0 1.79214V16.2194C0 17.4446 0.797623 18.0033 1.53896 18.0033C1.88807 18.0033 2.24376 17.8931 2.59707 17.6781L14.7944 10.2121C15.4075 9.83544 15.7519 9.27794 15.7411 8.68212C15.7309 8.0857 15.368 7.54078 14.7441 7.18808ZM13.977 8.87853L1.78028 16.3428C1.72089 16.3806 1.65663 16.4103 1.58926 16.4308C1.57203 16.3617 1.56397 16.2906 1.56531 16.2194V1.79274C1.56531 1.64423 1.59225 1.56938 1.59225 1.55082C1.64016 1.55381 1.72399 1.57836 1.82938 1.63825L13.9704 8.54918C14.1201 8.63482 14.1644 8.70907 14.1788 8.6929C14.171 8.71326 14.1201 8.78931 13.977 8.87853Z" fill="#003C07" />
        </svg>
    );
};

